import React, { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

export const WebPlanContext = createContext({
    currentWebPlan: 'three',
    setWebPlan: () => {}
});

export function WebPlanProvider({ children }) {
    const [currentWebPlan, setWebPlan] = useState('three');

    const value = useMemo(
        () => ({
            currentWebPlan,
            setWebPlan
        }),
        [currentWebPlan]
    );

    return <WebPlanContext.Provider value={value}>{children}</WebPlanContext.Provider>;
}

WebPlanProvider.propTypes = {
    children: PropTypes.node.isRequired
};
